import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedPhoneNumber from 'I18n/components/FormattedPhoneNumber';
import Subsection from 'settings-ui-lib/components/Subsection';
import SettingsRowButton from 'settings-ui-lib/components/SettingsRowButton';
import WithReAuth from 'two-factor-prompt-lib/containers/WithReAuth';
import DeleteTrustedNumberModalContainer from '../../containers/security/DeleteTrustedNumberModalContainer';
import UpdateTrustedNumberModalContainer from '../../containers/security/UpdateTrustedNumberModalContainer';
import SecurityPhoneNumberRecord from '../../records/security/SecurityPhoneNumber';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SecurityPhoneNumber = props => {
  const {
    onSetup,
    securityPhoneNumber,
    email,
    toggleDeleteTrustedNumberModal,
    toggleUpdateTrustedNumberModal,
    readOnly
  } = props;
  const setSecurityNumber = securityPhoneNumber.confirmedTime ? () => onSetup(true) : () => onSetup(false);
  return /*#__PURE__*/_jsx(Subsection, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "userPreferences.securityPhoneNumber.title"
    }),
    children: securityPhoneNumber.id && securityPhoneNumber.confirmedTime ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedPhoneNumber, {
        value: securityPhoneNumber.info
      }), /*#__PURE__*/_jsx(SettingsRowButton, {
        title: /*#__PURE__*/_jsx(WithReAuth, {
          onSuccess: toggleUpdateTrustedNumberModal,
          isDisabled: readOnly,
          email: email,
          skipVerificationIfNotSet: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "userPreferences.securityPhoneNumber.update"
          })
        })
      }), /*#__PURE__*/_jsx(SettingsRowButton, {
        title: /*#__PURE__*/_jsx(WithReAuth, {
          onSuccess: toggleDeleteTrustedNumberModal,
          isDisabled: readOnly,
          email: email,
          skipVerificationIfNotSet: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "userPreferences.securityPhoneNumber.delete"
          })
        })
      }), /*#__PURE__*/_jsx(DeleteTrustedNumberModalContainer, {}), /*#__PURE__*/_jsx(UpdateTrustedNumberModalContainer, {})]
    }) : /*#__PURE__*/_jsx(SettingsRowButton, {
      title: /*#__PURE__*/_jsx(WithReAuth, {
        onSuccess: setSecurityNumber,
        skipVerificationIfNotSet: false,
        email: email,
        isDisabled: readOnly,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.securityPhoneNumber.setup",
          "data-test-id": "security-phone-number-setup-button"
        })
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userPreferences.securityPhoneNumber.description"
      })
    })
  });
};
SecurityPhoneNumber.propTypes = {
  toggleDeleteTrustedNumberModal: PropTypes.func.isRequired,
  toggleUpdateTrustedNumberModal: PropTypes.func.isRequired,
  onSetup: PropTypes.func.isRequired,
  securityPhoneNumber: PropTypes.instanceOf(SecurityPhoneNumberRecord).isRequired,
  readOnly: PropTypes.bool
};
export default SecurityPhoneNumber;